import { render } from "./App.vue?vue&type=template&id=524bf4c9"
const script = {}

import "./App.vue?vue&type=style&index=0&id=524bf4c9&lang=scss"

import exportComponent from "/data/repos/49/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__